import styled from 'styled-components';

export const Circle = styled.div<{
  $size: number;
  $inverted?: boolean;
  /** Viktor's disc: the AI gradient in place of the brand red. */
  $viktor?: boolean;
}>`
  flex: none;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Inverted when the avatar is laid ON the brand red - a selected inbox row.
     Left alone it is a red disc on a red surface: an invisible circle with
     initials apparently floating in the row. */
  background: ${({ theme, $inverted, $viktor }) =>
    $inverted ? theme.white : $viktor ? theme.aiGradient : theme.primary};
  color: ${({ theme, $inverted }) => ($inverted ? theme.primary : theme.white)};
  font-size: ${({ $size }) => Math.round($size * 0.38)}px;
  font-weight: 600;
  line-height: 1;
  user-select: none;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /*
   * The group glyph, sized as a share of the circle rather than in px: the
   * avatar is 36px in the inbox and 48px on a phone, and an icon with one fixed
   * size would be a stamp in one and a smudge in the other. Width only, so the
   * icon keeps the proportions of its own box.
   *
   * Smaller than it looks on paper: a solid two-figure glyph reads far heavier
   * than two letters at the same measure, so it sits nearer the initials' own
   * weight than to the edge of the disc.
   */
  svg {
    width: 44%;
    height: auto;
  }

  /*
   * The AI stars are three thin shapes with air between them, so they want
   * more room than the solid group figures to read at the same weight. Kept
   * equal to the share AIStarsCutout draws them at, so the open card's disc
   * swaps in without the mark moving.
   */
  ${({ $viktor }) =>
    $viktor &&
    `
    svg {
      width: 60%;
    }
  `}

  /*
   * On the open entry card the disc is drawn by the icon itself - white with
   * the stars cut out, so the card's gradient shows through them - and this
   * box has to get out of its way: no fill of its own, and the svg is the
   * whole disc rather than a glyph in the middle of it. See AIStarsCutout.
   */
  ${({ $viktor, $inverted }) =>
    $viktor &&
    $inverted &&
    `
    background: transparent;

    svg {
      width: 100%;
      height: 100%;
    }
  `}
`;
